import React from 'react';
import withIcon from '../utilities/withIcon'; 

const IconGroup = () => {
  return (
      <g>
        <path
          d="m1.05 9 4.903.016c.54.001.984.41 1.04.936l.007.114v4.883c0 .541-.41.987-.936 1.044l-.114.006h-4.9a1.05 1.05 0 0 1-1.044-.936L0 14.95V10.05c0-.541.41-.987.936-1.044L1.051 9zm9 0 4.903.016c.54.001.984.41 1.04.936l.007.114v4.883c0 .541-.41.987-.936 1.044l-.114.006h-4.9a1.05 1.05 0 0 1-1.044-.936L9 14.95V10.05c0-.541.41-.987.936-1.044L10.05 9zM1.5 10.5v3.999h4v-3.985l-4-.014zm9 0v3.999h4v-3.985l-4-.014zM1.05 0l4.903.016c.54.001.984.41 1.04.936L7 1.066v4.883c0 .541-.41.987-.936 1.044l-.114.006h-4.9a1.05 1.05 0 0 1-1.044-.936L0 5.95V1.05C0 .509.41.063.936.006L1.05 0zm9 0 4.903.016c.54.001.984.41 1.04.936l.007.114v4.883c0 .541-.41.987-.936 1.044l-.114.006h-4.9a1.05 1.05 0 0 1-1.044-.936L9 5.95V1.05c0-.541.41-.987.936-1.044L10.05 0zM1.5 1.5v3.999h4V1.514l-4-.014zm9 0v3.999h4V1.514l-4-.014z"
          
        />
      </g>
  );
};

export default withIcon(IconGroup);
